<template>
  <ProductFormShablone :edit="edit" :id="id"/>
</template>
<script setup>
  import ProductFormShablone from '@/components/dashboard/bodys/product/form/ProductFormShablone.vue';
  import { computed, defineProps } from 'vue';
  const props = defineProps({
    edit:{
      type:Boolean,
      default:false
    },
    id:{
      type:Number,
      default:0
    }
  })
  const id=computed(()=>{return props.id})
  const edit=computed(()=>{return props.edit})
</script>